import { render } from "./CloudService.vue?vue&type=template&id=85a0c112"
import script from "./CloudService.vue?vue&type=script&lang=js"
export * from "./CloudService.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__